module.exports = __webpack_public_path__ + "img/dr_17.779c3ec3.png";